import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
export default function Header({ title, image, sold }) {
  return (
    <div className="h-[36rem] overflow-hidden grid">
      <div className="h-[36rem] col-start-1 row-start-1 z-0 relative">
        <GatsbyImage
          alt={title}
          className="h-[36rem] w-full"
          objectFit="cover"
          style={{
            imageRendering: "pixelated",
            msInterpolationMode: "nearest-neighbor",
          }}
          image={image}
        />
      </div>
      <div className="h-[36rem] col-start-1 row-start-1 relative z-10 bg-gray-800/50 contrast-125">
        <div className="h-full relative flex items-end justify-center pb-8">
          <div className="relative">
            <h1 className="text-white text-2xl md:text-5xl capitalize">
              {title}
            </h1>
            {sold && (
              <span className="bg-yellow-600 font-bold text-white px-5 py-1 z-10 absolute animate-pulse  rounded-lg uppercase tracking-widest text-xs -top-6">
                Sold
              </span>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
